<template>
  <div class="bg">
    <div class="content">
      <p class="historyBack">
        <el-button type="primary" size='small' icon="el-icon-d-arrow-left" @click="routerBack()">返回</el-button>
      </p>
      <div class="patent-info">
        <iframe class="iframe-info" :src="iframeSrc1" frameborder="0"></iframe> 
      </div>
      <div class="patent-info">
        <iframe class="iframe-info" :src="iframeSrc2" frameborder="0"></iframe> 
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'comparison',
    data() {
      return {
        iframeSrc1:'',
        iframeSrc2:''
      }
    },
    mounted: function () {
      let params=this.$route.params;
      if(params.id1){
        this.iframeSrc1='/#/main/informationComparison/'+params.id1
      }
      if(params.id2){
        this.iframeSrc2='/#/main/informationComparison/'+params.id2
      }
    },
    methods: {
      routerBack(){
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
  .bg {
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .content{
    width: 100%;
    max-width: 1920px;
    height: calc(100vh - 136px);
    flex-direction: column;
  }
  .patent-info {
    width: 50%;
    height: 100%;
    float: left;
  }
  .iframe-info{
    width:100%;
    height:100%;
    overflow-y: scroll;
  }
  ::-webkit-scrollbar { 
    display: none;
  }
  .historyBack{
      margin: 0px;
      padding: 0px 40px;
      color: #1287C9;
      cursor: pointer;
      background-color: #f7faff;
  }
</style>
